var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTutorialIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102.038,
    height: 117,
    viewBox: "0 0 102.038 117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#041e42}.cls-2{fill:#fff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    transform: "translate(-216.481 -5428)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_130"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_125"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    width: 39.742,
    height: 17.5,
    className: "cls-1",
    rx: 4,
    transform: "rotate(180 146.364 2723.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    d: "M288.729 5447.5h-31.743a5.006 5.006 0 0 1-5-5v-9.5a5.006 5.006 0 0 1 5-5h31.743a5.006 5.006 0 0 1 5 5v9.5a5.006 5.006 0 0 1-5 5zm-31.743-17.5a3 3 0 0 0-3 3v9.5a3 3 0 0 0 3 3h31.743a3 3 0 0 0 3-3v-9.5a3 3 0 0 0-3-3z",
    className: "cls-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    d: "M227.163 5473.4a1 1 0 0 1-.875-.514c-3.209-5.783-6.578-13.342-4.131-20.518 2.064-6.053 7.85-11.057 17.69-15.3a1 1 0 0 1 .791 1.837c-9.291 4.005-14.717 8.62-16.588 14.107-2.194 6.432.978 13.481 3.986 18.9a1 1 0 0 1-.873 1.485z",
    className: "cls-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    d: "M229.274 5467.9l4.307 15.11-11.287-10.932z",
    className: "cls-2"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_131"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    cx: 38.5,
    cy: 38.5,
    r: 38.5,
    className: "cls-2",
    transform: "translate(241.519 5463.482)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_132"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    d: "M300.519 5493.571h-14.3a31.52 31.52 0 0 0-50.43 0h-14.3a4 4 0 0 0-4 4v29.822a4 4 0 0 0 4 4h14.3a31.52 31.52 0 0 0 50.43 0h14.3a4 4 0 0 0 4-4v-29.822a4 4 0 0 0-4-4z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    d: "M261 5545a32.265 32.265 0 0 1-25.71-12.607h-13.809a5.007 5.007 0 0 1-5-5v-29.822a5.006 5.006 0 0 1 5-5h13.809a32.519 32.519 0 0 1 51.42 0h13.81a5.006 5.006 0 0 1 5 5v29.822a5.007 5.007 0 0 1-5 5h-13.81A32.261 32.261 0 0 1 261 5545zm-39.519-50.429a3 3 0 0 0-3 3v29.822a3 3 0 0 0 3 3h14.8l.3.4a30.518 30.518 0 0 0 48.83 0l.3-.4h14.8a3 3 0 0 0 3-3v-29.822a3 3 0 0 0-3-3h-14.8l-.3-.4a30.519 30.519 0 0 0-48.83 0l-.3.4z",
    className: "cls-2"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorialIcon4);
export default __webpack_public_path__ + "static/media/tutorial-icon-4.75eb4cb9711404d7c9b04867d7911661.svg";
export { ForwardRef as ReactComponent };